'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_SiteTables$$anon$15() {
}
export { $c_Lpresto_SiteTables$$anon$15 as $c_Lpresto_SiteTables$$anon$15 };
$p = $c_Lpresto_SiteTables$$anon$15.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_SiteTables$$anon$15;
/** @constructor */
function $h_Lpresto_SiteTables$$anon$15() {
}
export { $h_Lpresto_SiteTables$$anon$15 as $h_Lpresto_SiteTables$$anon$15 };
$h_Lpresto_SiteTables$$anon$15.prototype = $p;
$p.b6 = (function(_$38) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(_$38, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$39) => _$39.u3)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_Ordering$Boolean$());
});
var $d_Lpresto_SiteTables$$anon$15 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SiteTables$$anon$15, "presto.SiteTables$$anon$15", ({
  Rt: 1,
  G: 1
}));
export { $d_Lpresto_SiteTables$$anon$15 as $d_Lpresto_SiteTables$$anon$15 };
//# sourceMappingURL=presto.-Site-Tables$$anon$15.js.map
